<template>
  <vs-popup
      class="holamundo"
      :title="title"
      :active.sync="addNewDataLocal"
      @vs-close="closeForm">
    <form @submit.prevent>
      <div
          class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
        <label class="vs-input--label">Name<sup>*</sup></label>
        <div class="vs-con-input">
          <input
              type="text"
              v-model="name"
              name="name"
              class="vs-inputx vs-input--input normal"
              style="border: 1px solid rgba(0, 0, 0, 0.2)" />
        </div>
        <span></span>
      </div>
      <div
          class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
        <label class="vs-input--label">Email<sup>*</sup></label>
        <div class="vs-con-input">
          <input
              type="email"
              v-model="email"
              name="email"
              class="vs-inputx vs-input--input normal"
              style="border: 1px solid rgba(0, 0, 0, 0.2)" />
        </div>
        <span></span>
      </div>
      <div
          class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
        <label class="vs-input--label">Phone Number<sup>*</sup></label>
        <div class="vs-con-input">
          <input
              type="number"
              v-model="no_telp"
              name="no_telp"
              class="vs-inputx vs-input--input normal"
              style="border: 1px solid rgba(0, 0, 0, 0.2)" />
        </div>
        <span></span>
      </div>
      <div
          class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
        <label class="vs-input--label">New Password<sup>*</sup></label>
        <div class="vs-con-input">
          <input
              autocomplete="new_password"
              placeholder="Leave Empty if won't change"
              type="password"
              v-model="new_password"
              name="new_password"
              class="vs-inputx vs-input--input normal"
              onfocus="this.removeAttribute('readonly');"
              readonly
              style="border: 1px solid rgba(0, 0, 0, 0.2)" />
        </div>
        <span></span>
      </div>
      <!--<vs-input label="Name" name="name" v-model="name" class="w-full" />-->
      <!--<vs-input type="email" label="Email" name="email" v-model="email" class="mt-5 w-full" />-->
      <!--<vs-input type="number" label="Phone Number" name="phone" v-model="no_telp" class="mt-5 w-full" />-->
      <!--<vs-input v-if="editMode" placeholder="Leave Empty if won't change" type="password" label="New Password" name="password" v-model="new_password" class="mt-5 w-full" />-->
      <!--<vs-select autocomplete placeholder="- Select -" v-model="role_id" label="Role" class="w-full mb-6">-->
      <!--<vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in roleData" />-->
      <!--</vs-select>-->
      <div
          class="vs-component vs-con-input-label w-full vs-input mb-5 vs-input-primary">
        <label class="vs-input--label">Role<sup>*</sup></label>
        <v-select
            style="background: white"
            @input="(x) => (role_id = x.value)"
            :clearable="false"
            :value="getSelectValue(role_id, roleData)"
            :reduce="(text) => text.value"
            label="text"
            :options="roleData" />
      </div>
      <!--<vs-select autocomplete placeholder="- Select -" v-model="fleet_group_id" label="Fleet Group" class="w-full mb-6">-->
      <!--<vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in fleetData" />-->
      <!--</vs-select>-->
      <!-- <div
        class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
        <label class="vs-input--label">Fleet Group<sup>*</sup></label>
        <v-select
          style="background: white"
          @input="(x) => (fleet_group_id = x.value)"
          :clearable="false"
          :value="getSelectValue(fleet_group_id, fleetData)"
          :reduce="(text) => text.value"
          label="text"
          :options="fleetData" />
      </div> -->
      <div
          class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
        <vs-select
            placeholder="Search and select"
            class="selectExample w-full"
            label="Fleet Group(s)"
            label-placeholder="Fleet Group(s)"
            multiple
            autocomplete
            v-model="fleet_group_id">
          <!-- <vs-select-item :key="'all'" :value="'all'" :text="'All'" /> -->
          <div class="flex flex-row" style="gap: 10px">
            <vs-button class="w-full mb-1" size="small" @click="selectAllFleet"
            >Select All</vs-button
            >
            <vs-button
                class="w-full mb-1"
                color="danger"
                size="small"
                @click="deselectAllFleet"
            >Deselect All</vs-button
            >
          </div>
          <vs-select-item
              :key="index"
              :value="item.value"
              :text="item.text"
              v-for="(item, index) in fleetData" />
        </vs-select>
      </div>
      <!-- <div class="w-full mb-5">
        <label class="font-normal" for="fleet_group">Fleet Group</label>
        <v-select
          class="drop-height-auto"
          multiple
          placeholder="- Select Fleet Groups -"
          :clearable="true"
          v-model="fleet_group_id"
          label="text"
          :options="fleetData" />
      </div> -->
      <!--<vs-select placeholder="- Select -" v-model="is_active" label="Status" class="w-full mb-6">-->
      <!--<vs-select-item value="1" text="Active"  />-->
      <!--<vs-select-item value="0" text="Not Active"  />-->
      <!--</vs-select>-->
      <div
          class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
        <label class="vs-input--label">Status<sup>*</sup></label>
        <v-select
            style="background: white"
            @input="(x) => (is_active = x.value)"
            :clearable="false"
            :value="getSelectValue(is_active, active_array)"
            :reduce="(text) => text.value"
            label="text"
            :options="active_array" />
      </div>
    </form>
    <vs-divider />
    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-button
            class="mr-3 mb-2 btn-load-1 vs-con-loading__container"
            @click="submitForm"
            v-if="!editMode"
        >Submit
        </vs-button>
        <vs-button
            class="mr-3 mb-2 btn-load-2 vs-con-loading__container"
            @click="updateForm"
            v-if="editMode"
        >Update
        </vs-button>
        <vs-button
            color="danger"
            class="mr-3 mb-2 btn-load-3 vs-con-loading__container"
            @click="deleteData"
            v-if="editMode"
        >Delete
        </vs-button>
        <vs-button color="warning" type="border" class="mb-2" @click="closeForm"
        >Cancel</vs-button
        >
        <vs-button
            class="mr-3 mb-2 btn-load-4 vs-con-loading__container float-right"
            @click="resendActivation"
            v-if="editMode && dataEdit.is_active == 0"
        >Resend Activation
        </vs-button>
      </div>
    </div>
  </vs-popup>
</template>
<script>
import * as REPO from '../../repository/index'

export default {
  props: {
    addNewData: {
      type: Boolean,
      required: true,
    },
    title: String,
    allData: Array,
    roleData: Array,
    fleetData: Array,
    editMode: Boolean,
    dataEdit: Object,
  },
  data() {
    return {
      fleet_array: [],
      active_array: [
        {
          text: 'Active',
          value: 1,
        },
        {
          text: 'Inactive',
          value: 0,
        },
      ],
      role_array: [],
      name: '',
      new_password: '',
      role_id: '',
      is_active: 1,
      fleet_group_id: '',
      email: '',
      no_telp: '',
      is_selected: false,
    }
  },
  watch: {
    name(val) {
      this.name = val.toUpperCase()
    },
    // fleet_group_id(val) {
    //   console.log('fgid', val)
    // },
    // is_selected(val) {
    //   console.log('is_selected', val)
    // },
    editMode(val) {
      if (val) {
        this.name = this.dataEdit.name
        this.email = this.dataEdit.email
        this.no_telp = this.dataEdit.no_telp
        this.role_id = this.dataEdit.role_id
        let fgid = JSON.parse(this.dataEdit.fleet_group_ids)
        console.log('fgid test', fgid)
        this.fleet_group_id = fgid ? fgid : ''
        this.is_active = this.dataEdit.is_active
        //
      } else {
        //
      }
    },
  },
  mounted() {},
  computed: {
    addNewDataLocal: {
      get() {
        if (this.addNewData && this.editMode) {
          //
          this.name = this.dataEdit.name
          this.email = this.dataEdit.email
          this.no_telp = this.dataEdit.no_telp
          this.role_id = this.dataEdit.role_id
          let fgid = JSON.parse(this.dataEdit.fleet_group_ids)
          this.fleet_group_id = fgid ? fgid : ''
          this.is_active = this.dataEdit.is_active
        }
        if (this.addNewData && !this.editMode) {
          this.clearFields()
        }
        return JSON.parse(this.addNewData)
      },
      set(val) {
        if (!val) {
          //
          this.$emit('closeModal')
        }
      },
    },
    validateForm() {
      return !this.errors.any() && this.mailTo != ''
    },
  },
  methods: {
    selectAllFleet() {
      this.fleet_group_id = this.fleetData.map((x) => x.value)
    },
    deselectAllFleet() {
      this.fleet_group_id = []
    },
    resendActivation() {
      this.loadingBtnStart('btn-load-4')
      REPO.resendActivation(this.dataEdit.id)
          .then((res) => {
            if (res.data.status == 'true') {
              this.$toast.success('Email Successfully Sent')
            } else {
              throw { message: res.data.error_msg }
            }

            this.loadingBtnStop('btn-load-4')
          })
          .catch((err) => {
            //
            this.$toast.error(err.message)
            this.loadingBtnStop('btn-load-4')
          })
    },
    closeForm() {
      this.clearFields()
      this.$emit('closeModal', false)
    },
    clearFields() {
      this.name = ''
      this.email = ''
      this.no_telp = ''
      this.role_id = ''
      this.new_password = ''
      this.fleet_group_id = ''
      this.is_active = 1
    },
    loadingBtnStart(val) {
      this.$vs.loading({
        container: `.${val}`,
        scale: 0.45,
      })
    },
    loadingBtnStop(val) {
      this.$vs.loading.close(`.${val} > .con-vs-loading`)
    },
    submitForm() {
      this.loadingBtnStart('btn-load-1')
      let dataForm = {
        name: this.name,
        email: this.email,
        no_telp: this.no_telp,
        role_id: this.role_id,
        password: this.new_password,
        fleet_group_ids: this.fleet_group_id,
        is_active: this.is_active,
        created_by: this.$dataLocal.UserData().name,
      }
      REPO.postUser(dataForm)
          .then((res) => {
            this.loadingBtnStop('btn-load-1')
            if (res.data.status == 'true') {
              this.clearFields()

              this.$emit('submitModal', false)
              this.$toast.success('Data Successfullly Submitted')
            } else {
              throw { message: res.data.error_msg }
            }
          })
          .catch((err) => {
            this.loadingBtnStop('btn-load-1')
            //
            this.$toast.error(err.message)
          })
    },
    deleteData() {
      this.loadingBtnStart('btn-load-3')
      REPO.deleteUser(this.dataEdit.id)
          .then((res) => {
            this.clearFields()
            this.loadingBtnStop('btn-load-3')
            this.$emit('submitModal', false)
            this.$toast.error('Data Successfully Deleted')
          })
          .catch((err) => {
            //
            this.loadingBtnStop('btn-load-3')
            this.$toast.error(err.message)
          })
    },
    updateForm() {
      this.loadingBtnStart('btn-load-2')
      let dataForm = {
        name: this.name,
        email: this.email,
        no_telp: this.no_telp,
        role_id: this.role_id,
        fleet_group_ids: this.fleet_group_id,
        is_active: this.is_active,
        updated_by: this.$dataLocal.UserData().name,
      }
      if (this.new_password !== '') {
        dataForm.password = this.new_password
      }

      REPO.updateUser(dataForm, this.dataEdit.id)
          .then((res) => {
            this.clearFields()
            this.loadingBtnStop('btn-load-2')
            this.$emit('submitModal', false)
            this.$toast.success('Data Successfully Submitted')
          })
          .catch((err) => {
            //
            this.loadingBtnStop('btn-load-2')
            this.$toast.error(err.message)
          })
    },
  },
}
</script>

<style>
sup {
  color: red;
}
</style>
